import moment from 'moment';
import _ from 'lodash';

export const enumerateDaysBetweenDates = (startDate, endDate) => {
    const dates = [];

    const currDate = moment.utc(startDate).startOf('day');
    dates.push(currDate.clone().toDate())
    const lastDate = moment.utc(endDate).startOf('day');

    while (currDate.add(1, 'days').diff(lastDate) < 0) {
        dates.push(currDate.clone().toDate());
    }

    dates.push(lastDate.clone().toDate())

    return dates;
}

export const enumerateMonthsBetweenDates = (startDate, endDate) => {
    const dates = [];

    const currDate = moment.utc(startDate).endOf('month');
    dates.push(currDate.clone().toDate())
    const lastDate = moment.utc(endDate).endOf('month');

    while (currDate.add(1, 'months').diff(lastDate, 'months') < 0) {
        dates.push(currDate.clone().toDate());
    }

    dates.push(lastDate.clone().toDate())

    return dates;
}

const getUniqueWeekCommencingsBetweenDates = (startDate, endDate) => {
    const dates = enumerateDaysBetweenDates(startDate, endDate)

    const weekCommencingDates = dates.map(date => {
        return moment.utc(date).startOf('week').format('YYYY-MM-DD')
    })

    return _.uniq(weekCommencingDates)
}

const getWeekCommencingForDate = (date) => {
    return moment.utc(date).startOf('week').format('YYYY-MM-DD')
}

const isWeekend = (date) => {
    const dayNumber = moment.utc(date).day()
    return (dayNumber === 0 || dayNumber === 6)
}